import { Avatar, Segmented } from 'antd';
import TextArea from 'antd/es/input/TextArea';
import moment from 'moment';
import { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getFromStorage } from 'src/lib/storage';
import { editPromptOverrideAction } from 'src/modules/SuperAdmin/store/actions/promptoverrides.action';
import { getPromptOverridesByIdSlice } from 'src/modules/SuperAdmin/store/slices/promptoverrides.slice';
import * as Yup from 'yup';
import { SuperAdminModal } from '../../../baseComponents';
import './Promptoverrides.scss';

const EditPromptoverrides = ({
  isOpen,
  setIsOpen,
  selectedOrganizationUUID,
  selectedCondition,
}) => {
  const dispatch = useDispatch();
  const { currentPractitioner } = useSelector(
    (state) => state?.practitionerState
  );

  const cachedUserEmail = getFromStorage(`user_email`);
  const { practitionerList } = useSelector((state) => state?.practitionerState);
  const { getAllConditionsList } = useSelector(
    (state) => state?.conditionState
  );
  const { getPromptOverridesById } = useSelector(
    (state) => state?.promptOverrideState
  );
  const { getLlMVersionsList, promptScreens } = useSelector(
    (state) => state?.promptsState
  );

  const [conditionOptions, setConditionOptions] = useState([]);
  const [practitionerOptions, setPractitionerOptions] = useState([]);
  const [storePractitionerId, setStorePractitionerId] = useState(null);
  const [storeConditionId, setStoreConditionId] = useState(null);
  const [llmMaxTokenLimits, setLlmMaxTokenLimits] = useState({});
  const [storeLlmVersion, setStoreLlmVersion] = useState(null);
  const [promptScreenOptions, setPromptScreenOptions] = useState([]);
  const { getActiveOrganizationsList } = useSelector(
    (state) => state?.organizationState
  );
  const [organizationOptions, setOrganizationOptions] = useState([]);
  const [isOrganizationSelected, setIsOrganizationSelected] = useState(false);
  const [segmentedButtons, setSegmentedButtons] = useState([]);
  const [activeContent, setActiveContent] = useState('');
  const [activeButton, setActiveButton] = useState('');
  const [originalContent, setOriginalContent] = useState('');
  const [updatedPromptPayload, setUpdatedPromptPayload] = useState([]);

  // Prefix_suffix segmented button : Start
  const [staticSegmentedButtons, setStaticSegmentedButtons] = useState([]);
  const [staticActiveButton, setStaticActiveButton] = useState(null);
  const [staticActiveContent, setStaticActiveContent] = useState('');
  const [staticOriginalContent, setStaticOriginalContent] = useState('');
  const [updatedStaticPromptPayload, setUpdatedStaticPromptPayload] = useState(
    []
  );
  const [removedIndices, setRemovedIndices] = useState([]);
  const [removedByMatchIndices, setRemovedByMatchIndices] = useState([]);
  // End

  const formatDate = (date) => {
    // Parse the date string
    const convertedDate = moment(date, 'ddd, DD MMM YYYY HH:mm:ss [GMT]');

    // Format the date as "4th June 2024"
    const formattedDate = convertedDate?.format('Do MMMM YYYY');
    return formattedDate;
  };

  const [llmVersionOptions, setLlmVersionOptions] = useState([]);
  const [llmVariables, setLlmVariables] = useState([]);

  useEffect(() => {
    if (
      getPromptOverridesById?.LLM_variables &&
      Array.isArray(getPromptOverridesById?.LLM_variables)
    ) {
      let dataArr = [];
      getPromptOverridesById?.LLM_variables.forEach((key, index) => {
        dataArr.push({
          llm_id: key?.llm_id ? key?.llm_id : '',
          prompt_screen: key?.prompt_screen ? key?.prompt_screen : '',
          max_tokens: key?.max_tokens ? key?.max_tokens : '',
          temp: key?.temp ? key?.temp : '',
          top_p: key?.top_p ? key?.top_p : '',
          created_at: key?.created_at ? key?.created_at : '',
          created_by: key?.created_by ? key?.created_by : '',
          description: key?.description ? key?.description : '',
          feature_flags: key?.feature_flags ? key?.feature_flags : '',
          last_modified: key?.last_modified ? key?.last_modified : '',
          last_modified_by: key?.last_modified_by ? key?.last_modified_by : '',
          version: key?.version ? key?.version : '',
        });
      });
      setLlmVariables(dataArr);
    }
  }, [getPromptOverridesById?.LLM_variables]);

  const activeLLM = (button) => {
    const findVariable = (promptText) =>
      getPromptOverridesById?.LLM_variables?.find((variable) => {
        const normalizedPromptScreen = variable?.prompt_screen
          ?.toLowerCase()
          ?.replace(/_/g, ' ');
        return normalizedPromptScreen?.includes(promptText?.toLowerCase());
      });
    let result = findVariable(button);
    if (!result && button?.toLowerCase() === 'intake summary') {
      result = findVariable('followup summary');
    }
    if (!result && button?.toLowerCase() === 'intake chat') {
      result =
        findVariable('followup chat') ||
        findVariable('generic intake chat') ||
        findVariable('primary care intake chat') ||
        findVariable('primary care followup chat');
    }
    return result;
  };

  const [activeSegButton, setActiveSegButton] = useState('');

  useEffect(() => {
    if (isOpen) {
      const activeButtonDescription = activeLLM('intake chat')?.description;
      setActiveSegButton(activeButtonDescription);
    }
  }, [isOpen]);

  const initialValues = {
    org_id: getPromptOverridesById?.prompt?.organization_name,
    practitioner_name: getPromptOverridesById?.prompt?.practitioner_name,
    condition_id: getPromptOverridesById?.prompt?.condition_id,
    condition_name: getPromptOverridesById?.prompt?.condition_name,
    description: getPromptOverridesById?.prompt?.description
      ? getPromptOverridesById?.prompt?.description
      : getPromptOverridesById?.prompt?.description
        ? getPromptOverridesById?.prompt?.description
        : '',
    lumi_description: activeLLM('intake chat')?.description
      ? activeLLM('intake chat')?.description
      : null,
    intake_description: activeLLM('intake summary')?.description
      ? activeLLM('intake summary')?.description
      : null,
    prompt: getPromptOverridesById?.prompt?.prompt
      ? getPromptOverridesById?.prompt?.prompt
      : '',
    prompt_screen: getPromptOverridesById?.prompt?.prompt_screen
      ? getPromptOverridesById?.prompt?.prompt_screen
      : getPromptOverridesById?.prompt_screen,
    lumi_prompt_screen: activeLLM('intake chat')?.prompt_screen
      ? activeLLM('intake chat')?.prompt_screen
      : null,
    intake_prompt_screen: activeLLM('intake summary')?.prompt_screen
      ? activeLLM('intake summary')?.prompt_screen
      : null,
    prompt_name: getPromptOverridesById?.prompt?.prompt,
    max_token: activeLLM(getPromptOverridesById?.prompt?.prompt_screen)
      ?.max_tokens
      ? activeLLM(getPromptOverridesById?.prompt?.prompt_screen)?.max_tokens
      : null,
    lumi_max_tokens: activeLLM('intake chat')?.max_tokens || null,
    intake_max_tokens: activeLLM('intake summary')?.max_tokens || null,
    lumi_num_questions: activeLLM('intake chat')?.num_questions || null,
    llm_version: activeLLM(getPromptOverridesById?.prompt?.prompt_screen)
      ?.llm_id
      ? activeLLM(getPromptOverridesById?.prompt?.prompt_screen)?.llm_id
      : null,
    lumi_llm_version: activeLLM('intake chat')?.llm_id
      ? activeLLM('intake chat')?.llm_id
      : null,
    intake_llm_version: activeLLM('intake summary')?.llm_id
      ? activeLLM('intake summary')?.llm_id
      : null,
    temp: activeLLM(getPromptOverridesById?.prompt?.prompt_screen)?.temp
      ? activeLLM(getPromptOverridesById?.prompt?.prompt_screen)?.temp
      : null,
    lumi_temp: activeLLM('intake chat')?.temp
      ? activeLLM('intake chat')?.temp
      : null,
    intake_temp: activeLLM('intake summary')?.temp
      ? activeLLM('intake summary')?.temp
      : null,
    top_p: activeLLM(getPromptOverridesById?.prompt?.prompt_screen)?.top_p
      ? activeLLM(getPromptOverridesById?.prompt?.prompt_screen)?.top_p
      : null,
    lumi_top_p: activeLLM('intake chat')?.top_p
      ? activeLLM('intake chat')?.top_p
      : null,
    intake_top_p: activeLLM('intake summary')?.top_p
      ? activeLLM('intake summary')?.top_p
      : null,
    feature_flags: getPromptOverridesById?.prompt?.feature_flags
      ? getPromptOverridesById?.prompt?.feature_flags
      : '{}',
    lumi_feature_flags: activeLLM('intake chat')?.feature_flags
      ? activeLLM('intake chat')?.feature_flags
      : null,
    intake_feature_flags: activeLLM('intake summary')?.feature_flags
      ? activeLLM('intake summary')?.feature_flags
      : null,
    last_modified: getPromptOverridesById?.prompt?.last_modified
      ? formatDate(getPromptOverridesById?.prompt?.last_modified)
      : formatDate(getPromptOverridesById?.prompt?.created_at),
    lumi_last_modified: activeLLM('intake chat')?.last_modified
      ? formatDate(activeLLM('intake chat')?.last_modified)
      : formatDate(activeLLM('intake chat')?.created_at),
    intake_last_modified: activeLLM('intake summary')?.last_modified
      ? formatDate(activeLLM('intake summary')?.last_modified)
      : formatDate(activeLLM('intake summary')?.created_at),
    last_modified_by: getPromptOverridesById?.prompt?.last_modified_by
      ? getPromptOverridesById?.prompt?.last_modified_by
      : getPromptOverridesById?.prompt?.created_by,
    lumi_last_modified_by: activeLLM('intake chat')?.last_modified_by
      ? activeLLM('intake chat')?.last_modified_by
      : activeLLM('intake chat')?.created_by,
    intake_last_modified_by: activeLLM('intake summary')?.last_modified_by
      ? activeLLM('intake summary')?.last_modified_by
      : activeLLM('intake summary')?.created_by,
    version: getPromptOverridesById?.prompt?.version,
    lumi_version: activeLLM('intake chat')?.version
      ? activeLLM('intake chat')?.version
      : null,
    intake_version: activeLLM('intake summary')?.version
      ? activeLLM('intake summary')?.version
      : null,
  };

  const handleSegmented = (value) => {
    setActiveSegButton(value);
  };
  // Auto generated bg color for segmented buttons : Start
  const generateLighterColor = (color) => {
    const r = parseInt(color.substring(1, 3), 16);
    const g = parseInt(color.substring(3, 5), 16);
    const b = parseInt(color.substring(5, 7), 16);

    const lighterR = Math.round((r + 255) / 2.2);
    const lighterG = Math.round((g + 255) / 2.2);
    const lighterB = Math.round((b + 255) / 2.2);

    const lighterColor =
      '#' +
      lighterR.toString(16).padStart(2, '0') +
      lighterG.toString(16).padStart(2, '0') +
      lighterB.toString(16).padStart(2, '0');

    return lighterColor;
  };

  const hashCode = (str) => {
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
      hash = str.charCodeAt(i) + ((hash << 5) - hash);
    }
    return hash;
  };

  const intToRGB = (i) => {
    const c = (i & 0x00ffffff).toString(16).toUpperCase();
    return '00000'.substring(0, 6 - c.length) + c;
  };

  function stringToColor(str) {
    const hash = hashCode(str);
    const rgb = intToRGB(hash);
    const color = `#${rgb}`;
    return generateLighterColor(color);
  }
  // Auto generated bg color for segmented buttons : End

  useEffect(() => {
    if (
      getPromptOverridesById?.responses &&
      Array.isArray(getPromptOverridesById?.responses) &&
      getPromptOverridesById?.responses.length > 0 &&
      getPromptOverridesById?.prefix_suffix &&
      Array.isArray(getPromptOverridesById?.prefix_suffix)
    ) {
      // Convert prefix_suffix to a Set for efficient lookup
      const prefixSuffixSet = new Set(
        getPromptOverridesById.prefix_suffix.map((item) => JSON.stringify(item))
      );

      // Capture indices of responses to be removed based on matches
      const removedByMatchIndices = getPromptOverridesById.responses
        .map((response, index) => ({
          response,
          originalIndex: index + 1,
        }))
        .filter(
          ({ response }) =>
            response.prompt_override_id ===
            getPromptOverridesById.prompt?.prompt_override_id
        )
        .map(({ originalIndex }) => originalIndex);

      // Set indices captured by match state
      setRemovedByMatchIndices(removedByMatchIndices);

      // Filter responses to remove those that are also in prefix_suffix and those matching
      const filteredResponses = getPromptOverridesById.responses
        .map((response, index) => ({
          response,
          originalIndex: index + 1, // Store original index, adjusting to 1-based index
        }))
        .filter(
          ({ response, originalIndex }) =>
            !prefixSuffixSet.has(JSON.stringify(response)) &&
            !removedByMatchIndices.includes(originalIndex)
        );

      // Determine removed indices for prefix_suffix
      const removedIndices = getPromptOverridesById.responses
        .map((response, index) => ({
          response,
          originalIndex: index + 1,
        }))
        .filter(({ response }) => prefixSuffixSet.has(JSON.stringify(response)))
        .map(({ originalIndex }) => originalIndex);

      setRemovedIndices(removedIndices); // Set removed indices state

      const buttons = filteredResponses
        .map(({ response, originalIndex }) => {
          const filteredKeys = Object.keys(response).filter(
            (key) => key !== 'prompt_override_id' && key !== 'prompt_screens_id'
          );

          return filteredKeys.map((key) => {
            // Use prompt_override_id and prompt_screens_id to ensure uniqueness
            const uniqueKey = `${key}_${response.prompt_screens_id}_${response.prompt_override_id}`;
            const finalButtonNames = key.trim() === '' ? `No description` : key;

            return {
              label: finalButtonNames,
              value: uniqueKey,
              content: response[key],
              key: key,
              prompt_screen_id: response.prompt_screens_id,
              prompt_override_id: response.prompt_override_id,
              originalIndex, // Keep original index for avatar display
            };
          });
        })
        .filter(Boolean) // Remove nulls from filtering
        .flat();

      const buttonsWithAvatars = buttons.map((button) => {
        const dynamicBackgroundColor = stringToColor(
          `${button.originalIndex}_${button.value}`
        );

        return {
          ...button,
          label: (
            <div className="flex flex-col items-center">
              <Avatar
                size={24}
                className="text-sm flex items-center mt-1"
                style={{ backgroundColor: dynamicBackgroundColor }}
              >
                <div style={{ fontSize: '10px' }}>{button.originalIndex}</div>{' '}
                {/* Use originalIndex */}
              </Avatar>
              <div className="mt-2">{button.label}</div>
            </div>
          ),
        };
      });

      setSegmentedButtons(buttonsWithAvatars);

      if (buttonsWithAvatars.length > 0) {
        setActiveButton(buttonsWithAvatars[0].value);
        setActiveContent(buttonsWithAvatars[0].content);
        setOriginalContent(buttonsWithAvatars[0].content);
      }
    }
  }, [getPromptOverridesById]);

  useEffect(() => {
    if (
      getPromptOverridesById?.prefix_suffix &&
      Array.isArray(getPromptOverridesById?.prefix_suffix) &&
      getPromptOverridesById?.prefix_suffix.length > 0
    ) {
      const buttons = getPromptOverridesById.prefix_suffix
        .flatMap((item, originalIndex) => {
          const filteredKeys = Object.keys(item).filter(
            (key) => key !== 'prompt_override_id' && key !== 'prompt_screens_id'
          );

          return filteredKeys.map((key) => {
            // Use prompt_override_id and prompt_screens_id to ensure uniqueness
            const uniqueKey = `${key}_${item.prompt_screens_id}_${item.prompt_override_id}`;
            const finalButtonNames = key.trim() === '' ? `No description` : key;

            return {
              label: finalButtonNames,
              value: uniqueKey,
              content: item[key],
              key: key,
              prompt_screen_id: item.prompt_screens_id,
              prompt_override_id: item.prompt_override_id,
              originalIndex, // Track the original index
              missingButton: removedIndices[originalIndex] ?? originalIndex + 1,
            };
          });
        })
        .filter(Boolean); // Remove nulls from filtering

      const buttonsWithAvatars = buttons.map((button) => {
        const dynamicBackgroundColor = stringToColor(
          `${button.originalIndex + 1}_${button.value}`
        );
        return {
          ...button,
          label: (
            <div className="flex flex-col items-center">
              <Avatar
                size={24}
                className="text-sm flex items-center mt-1"
                style={{ backgroundColor: dynamicBackgroundColor }}
              >
                <div style={{ fontSize: '10px' }}>{button.missingButton}</div>
              </Avatar>
              <div className="mt-2">{button.label}</div>
            </div>
          ),
        };
      });

      setStaticSegmentedButtons(buttonsWithAvatars);

      if (buttonsWithAvatars.length > 0) {
        setStaticActiveButton(buttonsWithAvatars[0].value);
        setStaticActiveContent(buttonsWithAvatars[0].content);
        setStaticOriginalContent(buttonsWithAvatars[0].content);
      }
    }
  }, [getPromptOverridesById, removedIndices]);

  const handleSegmentChange = (value) => {
    const selectedButton = segmentedButtons.find(
      (button) => button.value === value
    );
    setActiveButton(value);
    value === 'intake_summary'
      ? setActiveContent(
          updatedPromptPayload?.length > 0
            ? updatedPromptPayload[0]?.intake_summary
            : selectedButton
              ? selectedButton.content
              : ''
        )
      : setActiveContent(selectedButton ? selectedButton.content : '');
    setOriginalContent(selectedButton ? selectedButton.content : ''); // Set the original content
  };

  const handleContentChange = (e) => {
    const newValue = e.target.value;
    setActiveContent(newValue);

    // Check if the content is different from the original content
    if (newValue !== originalContent) {
      const selectedButton = segmentedButtons.find(
        (button) => button.value === activeButton
      );
      // Payload set here  : Starts
      if (selectedButton) {
        setUpdatedPromptPayload([
          {
            [selectedButton.key]: newValue,
            prompt_screens_id: selectedButton.prompt_screen_id,
          },
        ]);
      }
    } else {
      setUpdatedPromptPayload([]);
    }
    // Ends
  };

  const handleStaticSegmentChange = (value) => {
    const selectedButton = staticSegmentedButtons.find(
      (button) => button.value === value
    );
    setStaticActiveButton(value);
    if (
      value.startsWith('Intake summary prompt') &&
      !value.includes('suffix') &&
      !value.includes('prefix')
    ) {
      if (updatedStaticPromptPayload.length > 0) {
        const updatedContent =
          updatedStaticPromptPayload[0]['Intake summary prompt'];
        setStaticActiveContent(updatedContent || '');
      } else {
        setStaticActiveContent(selectedButton.content);
      }
    } else {
      setStaticActiveContent(selectedButton ? selectedButton.content : '');
    }
    setStaticOriginalContent(selectedButton ? selectedButton.content : '');
  };

  const handleStaticContentChange = (e) => {
    const newValue = e.target.value;
    setStaticActiveContent(newValue);

    if (newValue !== staticOriginalContent) {
      const selectedButton = staticSegmentedButtons.find(
        (button) => button.value === staticActiveButton
      );
      if (selectedButton) {
        setUpdatedStaticPromptPayload([
          {
            [selectedButton.key]: newValue,
            prompt_screens_id: selectedButton.prompt_screen_id,
          },
        ]);
      }
    } else {
      setUpdatedStaticPromptPayload([]);
    }
  };

  useEffect(() => {
    if (promptScreens && Array.isArray(promptScreens)) {
      let dataArr = [];
      promptScreens.forEach((key, index) => {
        dataArr.push({
          value: key?.prompt_screens_id,
          label: key?.prompt_screen ? key?.prompt_screen : 'N/A',
          description: key?.description,
        });
      });
      setPromptScreenOptions(dataArr);
    }
  }, [promptScreens]);

  useEffect(() => {
    if (
      getActiveOrganizationsList &&
      Array.isArray(getActiveOrganizationsList)
    ) {
      let dataArr = [];
      getActiveOrganizationsList.forEach((key, index) => {
        dataArr.push({
          value: key?.org_id,
          label: key?.org_name,
          org_uuid: key?.org_uuid,
        });
      });
      setOrganizationOptions(dataArr);
    }
  }, [getActiveOrganizationsList]);

  useEffect(() => {
    if (practitionerList && Array.isArray(practitionerList)) {
      let dataArr = [];
      practitionerList.forEach((key, index) => {
        dataArr.push({
          value: key?.practitioner_id,
          label: key?.full_name,
        });
      });
      setPractitionerOptions(dataArr);
    }
  }, [practitionerList]);

  useEffect(() => {
    if (getAllConditionsList && Array.isArray(getAllConditionsList)) {
      const dataArr = getAllConditionsList.map((condition) => ({
        value: condition.condition_id,
        label: condition.condition_name ? condition.condition_name : 'N/A',
      }));
      setConditionOptions(dataArr);
    }
  }, [getAllConditionsList]);

  useEffect(() => {
    if (getLlMVersionsList && Array.isArray(getLlMVersionsList)) {
      let dataArr = [];
      let maxTokens = {};
      getLlMVersionsList.forEach((key, index) => {
        dataArr.push({
          value: key?.llm_version,
          label: key?.model ? key?.model : 'N/A',
          name: key?.max_tokens,
        });
        maxTokens[key?.llm_version] = key?.max_tokens;
      });
      setLlmVersionOptions(dataArr);
      setLlmMaxTokenLimits(maxTokens);
    }
  }, [getLlMVersionsList]);

  const customScrollbarStyle = {
    overflowY: 'hidden',
    overflowX: 'auto',
    scrollbarWidth: 'thin',
    scrollbarColor: '#ccc transparent',
    whiteSpace: 'nowrap',
  };

  const scrollContainerRef = useRef(null);

  useEffect(() => {
    if (isOpen && scrollContainerRef.current) {
      setTimeout(() => {
        scrollContainerRef.current.scrollLeft = 0;
      }, 100);
    }
  }, [isOpen]);

  const featureFlagsString = JSON.stringify(
    activeSegButton === activeLLM('intake chat')?.description &&
      llmVariables?.length === 2
      ? initialValues.lumi_feature_flags
      : activeSegButton === activeLLM('intake summary')?.description &&
          llmVariables?.length === 2
        ? initialValues.intake_feature_flags
        : llmVariables?.length === 1 &&
          activeLLM(getPromptOverridesById?.prompt?.prompt_screen)
            ?.feature_flags,
    null,
    2
  );

  const PromptsSegment = [
    {
      label: activeLLM('intake chat')?.description,
      isActive: activeButton === activeLLM('intake chat')?.description,
      onClick: () => setActiveSegButton(activeLLM('intake chat')?.description),
    },
    {
      label: activeLLM('intake summary')?.description,
      isActive: activeButton === activeLLM('intake summary')?.description,
      onClick: () =>
        setActiveSegButton(activeLLM('intake summary')?.description),
    },
  ];

  const sections = [
    {
      heading: (
        <>
          <div className="">
            Edit prompt override
            {getPromptOverridesById?.label === 'prompt_override' ? (
              <span className="mx-1 text-[#16a878] rounded-[25px] bg-[#eefaf4] justify-center  text-[15px] font-medium my-0.5 px-2">
                Override
              </span>
            ) : (
              ''
            )}
          </div>
        </>
      ),
      fields: [
        {
          name: 'sections',
          type: 'label',
          title: (
            <div>
              <div>
                {getPromptOverridesById?.LLM_variables?.length > 1 && (
                  <div className="flex -mb-2 py-2 ">
                    <div className="py-1 text-base">Prompt metadata :</div>
                    <div className="lg:flex pl-1 segmented_schedule rounded-lg w-fit">
                      <Segmented
                        options={PromptsSegment.map((button) => ({
                          label: button.label,
                          value: button.label,
                        }))}
                        value={activeSegButton}
                        onChange={(value) => handleSegmented(value)}
                      />
                    </div>
                  </div>
                )}
              </div>
            </div>
          ),
        },
      ],
    },
    {
      heading: (
        <>
          <div className=" flex gap-5">
            <div className="flex gap-1">
              <div className="font-bold text-sm">Organization name : </div>
              <div className="font-normal text-sm">
                {initialValues.org_id || ''}
              </div>
            </div>
            <div className="flex gap-1">
              <div className="font-bold text-sm">Practitioner name : </div>
              <div className="font-normal text-sm">
                {' '}
                {initialValues.practitioner_name || ''}
              </div>
            </div>
            <div className="flex gap-1">
              <div className="font-bold text-sm">Condition name : </div>
              <div className="font-normal text-sm">
                {initialValues.condition_name || 'N/A'}
              </div>
            </div>
            <div className="flex gap-1">
              <div className="font-bold text-sm">Prompt screen : </div>
              <div className="font-normal text-sm">
                {activeSegButton === activeLLM('intake chat')?.description &&
                llmVariables?.length === 2
                  ? initialValues.lumi_prompt_screen
                  : activeSegButton ===
                        activeLLM('intake summary')?.description &&
                      llmVariables?.length === 2
                    ? initialValues.intake_prompt_screen
                    : (llmVariables?.length === 1 &&
                        activeLLM(getPromptOverridesById?.prompt?.prompt_screen)
                          ?.prompt_screen) ||
                      ''}
              </div>
            </div>
          </div>
        </>
      ),
      fields: [],
    },
    {
      heading: (
        <>
          <div className="flex gap-5">
            <div className="flex gap-1">
              <div className="font-bold text-sm">Description : </div>
              <div className="font-normal text-sm">
                {activeSegButton === activeLLM('intake chat')?.description &&
                llmVariables?.length === 2
                  ? initialValues.lumi_description
                  : activeSegButton ===
                        activeLLM('intake summary')?.description &&
                      llmVariables?.length === 2
                    ? initialValues.intake_description
                    : llmVariables?.length === 1 &&
                      activeLLM(getPromptOverridesById?.prompt?.prompt_screen)
                        ?.description}
              </div>
            </div>
            <div className="flex gap-1">
              <div className="font-bold text-sm">Version : </div>
              <div className="font-normal text-sm">
                {activeSegButton === activeLLM('intake chat')?.description &&
                llmVariables?.length === 2
                  ? initialValues.lumi_version
                  : activeSegButton ===
                        activeLLM('intake summary')?.description &&
                      llmVariables?.length === 2
                    ? initialValues.intake_version
                    : (llmVariables?.length === 1 &&
                        activeLLM(getPromptOverridesById?.prompt?.prompt_screen)
                          ?.version) ||
                      ''}
              </div>
            </div>
            <div className="flex gap-1">
              <div className="font-bold text-sm">Last modified :</div>
              <div className="font-normal text-sm">
                {' '}
                {activeSegButton === activeLLM('intake chat')?.description &&
                llmVariables?.length === 2
                  ? initialValues.lumi_last_modified
                  : activeSegButton ===
                        activeLLM('intake summary')?.description &&
                      llmVariables?.length === 2
                    ? initialValues.intake_last_modified
                    : llmVariables?.length === 1 &&
                        activeLLM(getPromptOverridesById?.prompt?.prompt_screen)
                          ?.last_modified
                      ? formatDate(
                          activeLLM(
                            getPromptOverridesById?.prompt?.prompt_screen
                          )?.last_modified
                        )
                      : formatDate(
                          activeLLM(
                            getPromptOverridesById?.prompt?.prompt_screen
                          )?.created_at
                        ) || ''}
              </div>
            </div>
            <div className="flex gap-1">
              <div className="font-bold text-sm">Last modified by : </div>
              <div className="font-normal text-sm">
                {activeSegButton === activeLLM('intake chat')?.description &&
                llmVariables?.length === 2
                  ? initialValues.lumi_last_modified_by
                  : activeSegButton ===
                        activeLLM('intake summary')?.description &&
                      llmVariables?.length === 2
                    ? initialValues.intake_last_modified_by
                    : activeLLM(getPromptOverridesById?.prompt?.prompt_screen)
                          ?.last_modified_by
                      ? activeLLM(getPromptOverridesById?.prompt?.prompt_screen)
                          ?.last_modified_by
                      : activeLLM(getPromptOverridesById?.prompt?.prompt_screen)
                          ?.created_by || ''}
              </div>
            </div>
          </div>
        </>
      ),
      fields: [],
    },
    {
      heading: (
        <div className="flex gap-1">
          <div className="font-bold text-sm">Feature flags : </div>
          <div className="font-normal text-sm">{featureFlagsString}</div>
        </div>
      ),
      fields: [],
    },
    {
      className:
        (activeSegButton === activeLLM('intake chat')?.description &&
          llmVariables?.length === 2) ||
        (llmVariables?.length === 1 &&
          llmVariables[0]?.prompt_screen ===
            activeLLM('intake chat')?.prompt_screen)
          ? 'grid grid-cols-5 gap-3'
          : 'grid grid-cols-4 gap-4',
      fields: [
        {
          name:
            activeSegButton === activeLLM('intake chat')?.description &&
            llmVariables?.length === 2
              ? 'lumi_llm_version'
              : activeSegButton === activeLLM('intake summary')?.description &&
                  llmVariables?.length === 2
                ? 'intake_llm_version'
                : llmVariables?.length === 1 &&
                    llmVariables[0]?.prompt_screen ===
                      activeLLM('intake chat')?.prompt_screen
                  ? 'lumi_llm_version'
                  : 'intake_llm_version',
          type: 'select',
          title: 'LLM version',
          placeholder: 'Select LLM version',
          options: llmVersionOptions,
          onChange: (setFieldValue, e) => {
            if (
              activeSegButton === activeLLM('intake chat')?.description &&
              llmVariables?.length === 2
            ) {
              setFieldValue('lumi_llm_version', e);
            } else if (
              activeSegButton === activeLLM('intake summary')?.description &&
              llmVariables?.length === 2
            ) {
              setFieldValue('intake_llm_version', e);
            } else if (
              llmVariables?.length === 1 &&
              llmVariables[0]?.prompt_screen ===
                activeLLM('intake chat')?.prompt_screen
            ) {
              setFieldValue('lumi_llm_version', e);
            } else if (
              llmVariables?.length === 1 &&
              llmVariables[0]?.prompt_screen ===
                activeLLM('intake summary')?.prompt_screen
            ) {
              setFieldValue('intake_llm_version', e);
            }
            // setStoreLlmVersion(e);
          },
        },
        {
          name:
            activeSegButton === activeLLM('intake chat')?.description &&
            llmVariables?.length === 2
              ? 'lumi_max_tokens'
              : activeSegButton === activeLLM('intake summary')?.description &&
                  llmVariables?.length === 2
                ? 'intake_max_tokens'
                : llmVariables?.length === 1 &&
                    llmVariables[0]?.prompt_screen ===
                      activeLLM('intake chat')?.prompt_screen
                  ? 'lumi_max_tokens'
                  : 'intake_max_tokens',
          type: 'InputNumber',
          title: 'Max tokens',
          placeholder: 'Enter max tokens',
          onChange: (setFieldValue, e) => {
            if (
              activeSegButton === activeLLM('intake chat')?.description &&
              llmVariables?.length === 2
            ) {
              setFieldValue('lumi_max_tokens', e);
            } else if (
              (activeSegButton === 'Intake summary prompt' ||
                activeSegButton === 'Followup summary prompt') &&
              llmVariables?.length === 2
            ) {
              setFieldValue('intake_max_tokens', e);
            } else if (
              llmVariables?.length === 1 &&
              llmVariables[0]?.description ===
                activeLLM('intake chat')?.description
            ) {
              setFieldValue('lumi_max_tokens', e);
            } else if (
              llmVariables?.length === 1 &&
              llmVariables[0]?.prompt_screen ===
                activeLLM('intake summary')?.prompt_screen
            ) {
              setFieldValue('intake_max_tokens', e);
            }
          },
        },
        {
          name:
            activeSegButton === activeLLM('intake chat')?.description &&
            llmVariables?.length === 2
              ? 'lumi_temp'
              : activeSegButton === activeLLM('intake summary')?.description &&
                  llmVariables?.length === 2
                ? 'intake_temp'
                : llmVariables?.length === 1 &&
                    llmVariables[0]?.prompt_screen ===
                      activeLLM('intake chat')?.prompt_screen
                  ? 'lumi_temp'
                  : 'intake_temp',
          type: 'text',
          title: 'Temp',
          placeholder: 'Enter temp',
          onChange: (setFieldValue, e) => {
            if (
              activeSegButton === activeLLM('intake chat')?.description &&
              llmVariables?.length === 2
            ) {
              setFieldValue('lumi_temp', e.target.value);
            } else if (
              (activeSegButton === 'Intake summary prompt' ||
                activeSegButton === 'Followup summary prompt') &&
              llmVariables?.length === 2
            ) {
              setFieldValue('intake_temp', e.target.value);
            } else if (
              llmVariables?.length === 1 &&
              llmVariables[0]?.description ===
                activeLLM('intake chat')?.description
            ) {
              setFieldValue('lumi_temp', e.target.value);
            } else if (
              llmVariables?.length === 1 &&
              llmVariables[0]?.prompt_screen ===
                activeLLM('intake summary')?.prompt_screen
            ) {
              setFieldValue('intake_temp', e.target.value);
            }
          },
        },
        {
          name:
            activeSegButton === activeLLM('intake chat')?.description &&
            llmVariables?.length === 2
              ? 'lumi_top_p'
              : activeSegButton === activeLLM('intake summary')?.description &&
                  llmVariables?.length === 2
                ? 'intake_top_p'
                : llmVariables?.length === 1 &&
                    llmVariables[0]?.prompt_screen ===
                      activeLLM('intake chat')?.prompt_screen
                  ? 'lumi_top_p'
                  : 'intake_top_p',
          type: 'InputNumber',
          title: 'Top_p',
          placeholder: 'Enter top_p',
          onChange: (setFieldValue, e) => {
            if (
              activeSegButton === activeLLM('intake chat')?.description &&
              llmVariables?.length === 2
            ) {
              setFieldValue('lumi_top_p', e);
            } else if (
              (activeSegButton === 'Intake summary prompt' ||
                activeSegButton === 'Followup summary prompt') &&
              llmVariables?.length === 2
            ) {
              setFieldValue('intake_top_p', e);
            } else if (
              llmVariables?.length === 1 &&
              llmVariables[0]?.prompt_screen ===
                activeLLM('intake chat')?.prompt_screen
            ) {
              setFieldValue('lumi_top_p', e);
            } else if (
              llmVariables?.length === 1 &&
              llmVariables[0]?.prompt_screen ===
                activeLLM('intake summary')?.prompt_screen
            ) {
              setFieldValue('intake_top_p', e);
            }
          },
        },
        ...((activeSegButton === activeLLM('intake chat')?.description &&
          llmVariables?.length === 2) ||
        (llmVariables?.length === 1 &&
          llmVariables[0]?.prompt_screen ===
            activeLLM('intake chat')?.prompt_screen)
          ? [
              {
                name: 'lumi_num_questions',
                type: 'InputNumber',
                title: 'Num_questions',
                placeholder: 'Enter num_questions',
                onChange: (setFieldValue, e) => {
                  setFieldValue('lumi_num_questions', e);
                },
              },
            ]
          : []),
      ],
    },
    {
      heading: '',
      fields: [
        {
          name: 'prompt_name',
          type: (() => {
            try {
              JSON.parse(initialValues.prompt_name);
              return 'keyValueTextArea';
            } catch (e) {
              return 'modalTextArea';
            }
          })(),
          title: (
            <>
              <div
                className={`flex items-center${initialValues?.description?.length >= 33 ? 'mt-6' : ''}`}
              >
                <div className="">{initialValues?.description || ''}</div>
                {removedByMatchIndices?.length > 0 &&
                  (segmentedButtons?.length > 0 ||
                    staticSegmentedButtons?.length > 0) && (
                    <div className="ml-2 flex">
                      <Avatar
                        size={24}
                        className="text-sm flex items-center mb-1 bg-[#00d091]"
                      >
                        <div style={{ fontSize: '10px' }}>
                          {' '}
                          {removedByMatchIndices[0]}
                        </div>
                      </Avatar>
                    </div>
                  )}
              </div>
            </>
          ),
          placeholder: 'Enter prompt',
          className: 'w-full',
        },
      ],
    },
    //  Static Segmented Tab : Starts
    {
      heading: staticSegmentedButtons?.length > 0 &&
        removedIndices?.length > 0 && (
          <div className="py-2">
            <div
              className="segmented_super_admin rounded-lg w-full mb-5 flex overflow-auto"
              style={{ ...customScrollbarStyle }}
            >
              <Segmented
                style={{ fontSize: '12px' }}
                options={staticSegmentedButtons}
                onChange={handleStaticSegmentChange}
                value={staticActiveButton}
              />
            </div>
            {staticActiveButton.startsWith('Intake summary prompt') && (
              <div className="text-xs ml-1 bg-[#00d091] w-fit rounded-full px-2 py-1 mb-2 text-[#fff]">
                This prompt is editable
              </div>
            )}
            <div>
              <TextArea
                className={`${
                  staticActiveButton.includes('suffix prompt') ||
                  staticActiveButton.includes('prefix prompt')
                    ? 'modal__form-el-field-textarea_reduced'
                    : 'modal__form-el-field-textarea'
                }${
                  staticActiveButton.startsWith('Intake summary prompt')
                    ? ' mt-2'
                    : ''
                }`}
                value={staticActiveContent ? staticActiveContent : ''}
                bordered={false}
                autoSize={{ minRows: 3, maxRows: 13 }}
                onChange={handleStaticContentChange}
                readOnly={
                  !staticActiveButton.startsWith('Intake summary prompt')
                }
                style={{ fontWeight: 400 }}
              />
            </div>
          </div>
        ),
      fields: [],
    },
    //  Ends

    //  Segmented Tab : Starts
    {
      heading: segmentedButtons?.length > 0 && (
        <div className="py-5">
          <div
            className="segmented_super_admin rounded-lg w-full mb-5 flex overflow-auto"
            style={{ ...customScrollbarStyle }}
            ref={scrollContainerRef}
          >
            <Segmented
              style={{ fontSize: '12px' }}
              options={segmentedButtons}
              onChange={handleSegmentChange}
              value={activeButton}
            />
          </div>
          <div>
            <TextArea
              className={`${
                activeButton.includes('suffix prompt') ||
                activeButton.includes('prefix prompt')
                  ? 'modal__form-el-field-textarea_reduced'
                  : 'modal__form-el-field-textarea'
              }${
                activeButton.startsWith('Intake summary prompt') ? ' mt-2' : ''
              }`}
              value={activeContent ? activeContent : ''}
              bordered={false}
              autoSize={{ minRows: 3, maxRows: 13 }}
              onChange={handleContentChange}
              readOnly
            />
          </div>
        </div>
      ),
      fields: [],
    },
    // Ends
  ];

  const llm_schema = (type, llmVariables, activeLLM, initialValues) => {
    const isLumi = (desc) =>
      desc?.includes(activeLLM('intake chat')?.description);
    const isIntake = (desc) =>
      desc?.includes(activeLLM('intake summary')?.description);

    const getPrefix = () => {
      if (llmVariables?.length === 2) {
        return ['lumi', 'intake'];
      } else if (llmVariables?.length === 1) {
        return [isLumi(llmVariables[0]?.description) ? 'lumi' : 'intake'];
      }
      return ['intake'];
    };

    const prefixes = getPrefix();
    return prefixes.map(
      (prefix) => `${prefix}_${type === 'llm_id' ? 'llm_version' : type}`
    );
  };

  const createValidationSchema = (
    llmVariables,
    activeLLM,
    initialValues,
    llmMaxTokenLimits
  ) => {
    const schema = {};

    ['top_p', 'max_tokens', 'temp', 'llm_id'].forEach((type) => {
      const fields = llm_schema(type, llmVariables, activeLLM, initialValues);

      fields.forEach((field) => {
        if (type === 'top_p' || type === 'temp') {
          schema[field] = Yup.number()
            .typeError(
              `${type.charAt(0).toUpperCase() + type.slice(1)} must be a number`
            )
            .required(
              `${type.charAt(0).toUpperCase() + type.slice(1)} is required`
            )
            .min(
              0,
              `${
                type.charAt(0).toUpperCase() + type.slice(1)
              } must be at least 0`
            )
            .max(
              1,
              `${
                type.charAt(0).toUpperCase() + type.slice(1)
              } must be at most 1`
            )
            .test(`${field}-debug`, `Debugging ${field}`, function (value) {
              return true;
            });
        } else if (type === 'max_tokens') {
          schema[field] = Yup.number()
            .typeError('Max tokens must be a number')
            .required('Max tokens is required')
            .positive('Max tokens must be greater than 0')
            .integer('Max tokens must be an integer')
            .test(
              'max-token',
              'Max tokens exceeds the allowed limit',
              function (value) {
                const llm_id_field = field.startsWith('lumi')
                  ? 'lumi_llm_version'
                  : 'intake_llm_version';
                const llm_version = this?.parent[llm_id_field];
                const maxToken = llmMaxTokenLimits[llm_version];

                if (maxToken && value > maxToken) {
                  return this.createError({
                    message: `Max tokens exceeds the allowed limit of ${maxToken}`,
                    path: this.path,
                  });
                }

                return true;
              }
            );
        } else if (type === 'llm_id') {
          schema[field] = Yup.string()
            .required('LLM version is required')
            .test(`${field}-debug`, `Debugging ${field}`, function (value) {
              return true;
            });
        }
      });
    });

    schema.prompt_name = Yup.string()
      .required(`${initialValues?.description} is required`)
      .test('prompt_name-debug', 'Debugging prompt_name', function (value) {
        return true;
      });

    return Yup.object().shape(schema);
  };

  const validationSchemaField = createValidationSchema(
    llmVariables,
    activeLLM,
    initialValues,
    llmMaxTokenLimits
  );

  return (
    <SuperAdminModal
      open={isOpen}
      sections={sections}
      initialValues={initialValues}
      validationSchema={validationSchemaField}
      className={`overrides-modal`}
      closable={true}
      submitButtonText="Submit"
      cancelButtonText="Cancel"
      handleCancel={() => {
        setIsOpen(false);
        dispatch(getPromptOverridesByIdSlice(null));
        setUpdatedPromptPayload([]);
        setSegmentedButtons([]);
        setRemovedIndices([]);
        setActiveSegButton(activeLLM('intake chat')?.description);
      }}
      handleSubmit={(values) => {
        const intakeVariables = activeLLM('intake summary');
        const llmVariables = activeLLM('intake chat');

        const payload = {
          condition_id: values?.condition_id,
          practitioner_id: getPromptOverridesById?.prompt?.practitioner_id,
          description: getPromptOverridesById?.prompt?.description,
          prompt_screens_id: getPromptOverridesById?.prompt?.prompt_screens_id,
          lumi_max_tokens: values?.lumi_max_tokens,
          lumi_llm_version: values?.lumi_llm_version,
          lumi_temp: values?.lumi_temp,
          lumi_top_p: values?.lumi_top_p,
          lumi_num_questions: values?.lumi_num_questions,
          intake_max_tokens: values?.intake_max_tokens,
          intake_llm_version: values?.intake_llm_version,
          intake_temp: values?.intake_temp,
          intake_top_p: values?.intake_top_p,
          intake_prompt_id: intakeVariables?.prompt_id
            ? intakeVariables?.prompt_id
            : null,
          lumi_prompt_id: llmVariables?.prompt_id
            ? llmVariables?.prompt_id
            : null,
          prompt: values?.prompt_name,
          last_modified_by: cachedUserEmail,
          ...(updatedStaticPromptPayload.length > 0 && {
            edit_prompt_summary: updatedStaticPromptPayload,
          }),
        };
        dispatch(
          editPromptOverrideAction(
            getPromptOverridesById?.prompt?.prompt_override_id,
            payload,
            setIsOpen,
            setIsOrganizationSelected,
            selectedOrganizationUUID,
            setSegmentedButtons,
            selectedCondition,
            setRemovedIndices,
            setUpdatedStaticPromptPayload,
            () => setActiveSegButton(activeLLM('intake chat')?.description)
          )
        );
      }}
    />
  );
};

export default EditPromptoverrides;
